import { render, staticRenderFns } from "./PreSettleDetail.vue?vue&type=template&id=63825dba&scoped=true"
import script from "./PreSettleDetail.vue?vue&type=script&lang=js"
export * from "./PreSettleDetail.vue?vue&type=script&lang=js"
import style0 from "./PreSettleDetail.vue?vue&type=style&index=0&id=63825dba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63825dba",
  null
  
)

export default component.exports